// extracted by mini-css-extract-plugin
module.exports = {"ManualNav":"ManualNav_ManualNav__3dqmy"};